import { IMAGE_URL } from "../../URL";
import "./user.css";
export const User = ({ el, user, className = "" }) => {
    const currentUser = el || user;

    const avatar = currentUser?.user_settings?.avatar;
    const avatarUrl = avatar?.url;
    const crop = avatar?.avatar_crop;

    const fullAvatarUrl = avatarUrl
        ? avatarUrl.startsWith("http")
            ? avatarUrl
            : `${IMAGE_URL}/media/${avatarUrl.replace(/^\/?media\//, "")}`
        : null;

    return (
        <div
            className={`userAvatar ${className}`}
            style={
                fullAvatarUrl
                    ? {
                        backgroundImage: `url(${fullAvatarUrl})`,
                        backgroundSize: `${(crop?.zoom || 1) * 100}%`,
                        backgroundPosition: crop
                            ? `calc(50% + ${crop.x / 10}px) calc(50% + ${crop.y / 10}px)`
                            : "center",
                        backgroundRepeat: "no-repeat",
                    }
                    : {
                        background: `linear-gradient(315deg, ${
                            currentUser?.user_settings?.bg_gradient?.color1 || "#667eea"
                        } 0%, ${
                            currentUser?.user_settings?.bg_gradient?.color2 || "#764ba2"
                        } 100%)`,
                    }
            }
        >
            {!fullAvatarUrl && currentUser?.email?.slice(0, 2).toUpperCase()}
        </div>
    );
};